import React from "react";
import styles from "./FooterComp.module.scss";
import FooterLogo from "../../Components/assets/Images/FooterCompanyLogo.svg";
import SendMailIcon from "../../Components/assets/Images/footerSendmailicon.svg";
import TwitterIcon from "../../Components/assets/Images/ico-twitter.svg";
import LinkedInIcon from "../../Components/assets/Images/ico-linkedin.svg";
import InstaIcon from "../../Components/assets/Images/ico-insta.svg";
import YoutubeIcon from "../../Components/assets/Images/ico-youtube.svg";
import GithubIcon from "../../Components/assets/Images/githubblack.svg";
import GooglePlayStoreIcon from "../../Components/assets/Images/GooglePlayStore.svg";
import logo from "../assets/Images/CompanyLogo.svg";
import FirtsockLogo from "../assets/Images/firstockLogoBadge.svg";
import AppStoreIcon from "../../Components/assets/Images/AppStore.svg";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";

function FooterComp() {
  return (
    <div className={styles.mainWrapper}>
      <div className={styles.wrapper}>
        <div className={styles.wrapperTopContent}>
          <div className={styles.logoSection}>
            <div className={styles.siteMapingAlignLeft}>
              <div className={styles.footermainlogo}>
              <img src={FirtsockLogo} className={styles.footerLogo} />
              Firstock
              </div>

              <div className={styles.sublinksnotdesc}>
                Take control of your wealth with Firstock. Track your
                investments, trade wisely—all in one easy-to-use platform.
              </div>

              <div className={styles.centerSection}>
                <div className={styles.socialMediaLinks}>
                  <a
                    href="https://www.linkedin.com/company/thefirstock/"
                    target="_blank"
                  >
                    <img
                      src={LinkedInIcon}
                      alt="image"
                      className={styles.icons}
                    />
                  </a>
                  <a
                    href="https://www.instagram.com/firstockbroking"
                    target="_blank"
                  >
                    <img src={InstaIcon} alt="image" className={styles.icons} />
                  </a>
                  <a href="https://x.com/thefirstock" target="_blank">
                    <img
                      src={TwitterIcon}
                      alt="image"
                      className={styles.icons}
                    />
                  </a>
                  <a
                    href="https://www.youtube.com/@FirstockBroking"
                    target="_blank"
                  >
                    <img
                      src={YoutubeIcon}
                      alt="image"
                      className={styles.icons}
                    />
                  </a>
                </div>
              </div>
            </div>

            <div className={styles.smright}>
              <div className={styles.linksandsublinksapps}>
                <div className={styles.linksandsublinksappstext}>
                  <a
                    target="_blank"
                    className={styles.siteMapingLinks}
                    style={{ fontWeight: 400 }}
                  >
                    Download the App now
                  </a>
                  <a target="_blank" className={styles.sublinks}>
                    <span className={styles.toUnderline}>
                      Invest in Stocks, Mutual Funds, IPOs, Bonds, ETFs &
                      Futures, Options
                    </span>
                  </a>
                </div>
                <div className={styles.sendMail}>
                  <div className={styles.appsContainer}>
                    <a
                      href="https://apps.apple.com/app/firstock-trade-invest/id6746480444"
                      target="_blank"
                    >
                      <img
                        src={
                          "https://firstock-common.s3.ap-south-1.amazonaws.com/icons/png-template-icon/LightModeAppStore.png"
                        }
                        className={styles.Appstoreimage}
                      />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=in.firstock.mobile"
                      target="_blank"
                    >
                      <img
                        src={
                          "https://firstock-common.s3.ap-south-1.amazonaws.com/icons/png-template-icon/LightModeGoogle.png"
                        }
                        className={styles.Googlestoreimage}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.divider}></div>
          <div className={styles.siteMaping}>
            <div className={styles.siteMapingAlign}>
              <div className={styles.linksandsublinks}>
                <a className={styles.siteMapingLinks}>Company</a>
                <a
                  href="https://firstock.in/about"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>About Us</span>
                </a>
                <a
                  href="https://firstock.in/products"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Product</span>
                </a>
                <a
                  href="https://firstock.in/pricing"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Pricing</span>
                </a>
                <a
                  href="https://firstock.in/companyprofile"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Company Profile</span>{" "}
                </a>

                <a
                  href="https://partner.thefirstock.com/home"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Become a Partner</span>{" "}
                </a>

                <a
                  href="https://firstock.in/contact"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Contact Us</span>{" "}
                </a>
              </div>

              <div className={styles.linksandsublinks}>
                <a target="_blank" className={styles.siteMapingLinks}>
                  Offerings
                </a>
                <a
                  href="https://firstock.in/stocksAndEtf"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Contact Us</span>{" "}
                </a>
                <a
                  href="https://firstock.in/futuresAndOptions"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Future & Options</span>{" "}
                </a>
                <a
                  href="https://firstock.in/comingsoon"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>
                    Gold Bonds & Govt. Sec
                  </span>{" "}
                </a>
                <a
                  href="https://firstock.in/comingsoon"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Mutual Funds</span>{" "}
                </a>
                <a
                  href="https://firstock.in/comingsoon"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>IPO</span>{" "}
                </a>
                <a
                  href="https://firstock.in/developerApi"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Developer API</span>{" "}
                </a>
              </div>
              <div className={styles.linksandsublinks}>
                <a target="_blank" className={styles.siteMapingLinks}>
                  Support
                </a>
                <a
                  href="https://firstock.in/support"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Account Opening</span>{" "}
                </a>
                <a
                  href="https://firstock.in/support/"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Fund Transfer</span>{" "}
                </a>
                <a
                  href="https://firstock.in/pricing"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>List of Charges</span>{" "}
                </a>
                <a
                  href="https://firstock.in/downloads"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Downloads</span>{" "}
                </a>
                <a
                  href="https://firstock.in/support/"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Support Portal</span>{" "}
                </a>
                <a
                  href="https://firstock.in/support"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Raise a Ticket</span>{" "}
                </a>
              </div>
              <div className={styles.linksandsublinks}>
                <a target="_blank" className={styles.siteMapingLinks}>
                  Utilities
                </a>
                <a
                  href="https://firstock.in/brokerageCalculator"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>
                    Brokerage Calculator
                  </span>{" "}
                </a>
                <a
                  href="https://firstock.in/marginCalculator"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Margin Calculator</span>{" "}
                </a>
                <a
                  href="https://firstock.in/approvedListofSecurities"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>
                    Margin Approved Securities
                  </span>{" "}
                </a>
                <a
                  href="https://firstock.in/noticeBoard"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Notice Board</span>{" "}
                </a>
                <a
                  href="https://firstock.in/holidayCalender"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Holiday Calendar</span>{" "}
                </a>
                <a
                  href="https://firstock.in/referralProgramme"
                  target="_blank"
                  className={styles.sublinks}
                >
                  <span className={styles.toUnderline}>Referral Programme</span>{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.divider} style={{ marginTop: "10px" }}></div>
        <div className={styles.linksandsublinksLeft}>
          <div className={styles.ftdiv}>
            <a target="_blank" className={styles.sublinksnotAddressTitle}>
              Firstock Broking Pvt Ltd
            </a>
            <a target="_blank" className={styles.bottomNavLink}>
              @2025 Firstock All Rights Reserved.
            </a>
          </div>
          <a target="_blank" className={styles.sublinksnotAddress}>
            <li>
              {" "}
              No 350,1st Floor, 36th A Cross 7th Main Rd 5th Block Jayanagar,
              Bengaluru, KA 560041.
            </li>
          </a>
          <a target="_blank" className={styles.sublinksnotAddress}>
            <li> NSE​ &​ BSE – SEBI Registration No.: INZ000260334</li>
          </a>
          <a target="_blank" className={styles.sublinksnotAddress}>
            <li>
              {" "}
              CDSL: Depository services – SEBI Registration No.: IN-DP-67-2015
              Mutual Fund ARN: 132812.
            </li>
          </a>
          <a target="_blank" className={styles.sublinksnotAddress}>
            For any complaints pertaining to securities broking please write to
            complaints@firstock.in for DP related to depository@firstock.in
            Please ensure you carefully read the Risk Disclosure Document as
            prescribed by SEBI.
          </a>
        </div>
        <div className={styles.descriptionSection}>
          <div className={styles.descriptiontitle}>Attention Investors:</div>
          <p className={styles.description}>
            Investments in the securities market are subject to market risks.
            Please read all related documents carefully before investing.
            <br />
            Prevent Unauthorized Transactions in Your Trading/Demat Account:
            <br />
            Update your mobile number and email ID with your stock broker or
            depository participant. Receive alerts and information about your
            transactions on your registered mobile number/email for all debit
            and other important transactions in your trading/demat account
            directly from the Exchange/CDSL on the same day.
            <br />
            KYC is a one-time exercise while dealing in the securities market.
            <br />
            Once KYC is completed through a SEBI-registered intermediary
            (broker, DP, mutual fund, etc.), you do not need to undergo the same
            process again when approaching another intermediary.
            <br />
            No need to issue cheques when subscribing to an IPO.
            <br /> Simply write your bank account number and sign the
            application form to authorize your bank to make the payment in case
            of allotment. There is no worry about refunds, as the money remains
            in the investor's account.
            <br />
            Procedure to file a complaint on SCORES (Easy & Quick):
            <br />
            Register on the SCORES portal and keep the following mandatory
            details ready: Name, PAN, Address, Mobile Number, and Email ID.
            <br />
            Benefits: Effective communication and speedy redressal of
            grievances.
          </p>

          <div className={styles.descriptiontitle}>Dear Investor,</div>
          <p className={styles.description}>
            If you are subscribing to an IPO, there is no need to issue a
            cheque. Please write your bank account number and sign the IPO
            application form to authorize your bank to make the payment in case
            of allotment. In case of non-allotment, the funds will remain in
            your bank account. As a business, we do not provide stock tips and
            have not authorized anyone to trade on behalf of others.
          </p>

          <div className={styles.descriptiontitle}>Important:</div>
          <p className={styles.description}>
            Stock brokers can accept securities as margin from clients only by
            way of a pledge in the depository system w.e.f. September 1, 2020.
            <br />
            Update your email ID and mobile number with your stock broker or
            depository participant and receive OTPs directly from the depository
            on your registered email ID and/or mobile number to create pledges.
            <br />
            Check your securities, mutual funds, and bonds in the consolidated
            account statement issued by NSDL/CDSL every month.
          </p>

          <div className={styles.descriptiontitle}>Disclaimer:</div>
          <p className={styles.description}>
            The Stock Exchange, Mumbai, is not in any manner answerable,
            responsible, or liable to any person for any acts of omission or
            commission, errors, mistakes, and/or violations—actual or
            perceived—by us or our partners, agents, associates, etc., of any
            rules, regulations, by-laws of the Stock Exchange, SEBI Act, or any
            other laws in force from time to time. The Stock Exchange, Mumbai,
            is not responsible or liable for any information on this website or
            for any services rendered by our employees or representatives.
            Please refer to BSE compliance for more details.
          </p>

          <div className={styles.descriptiontitle}>Investor Alert:</div>
          <p className={styles.description}>
            Investors are requested to note that stock broker Firstock Broking
            Private Limited (Firstock) is permitted to receive/pay money from/to
            investors only through designated bank accounts, named as "client
            bank accounts."
            <br />
            Firstock is also required to disclose these client bank accounts to
            the Stock Exchange.
            <br />
            Hence, you are requested to use only the following client bank
            accounts for any transactions in your trading account with us. The
            details of these accounts are also displayed by the Stock Exchanges
            on their website under “Know / Locate Your Stock Broker.”
          </p>
        </div>
      </div>
      <div
        className={styles.divider}
        style={{ width: "85%", margin: "40px auto 0px" }}
      ></div>
      <div className={styles.bottomLinks}>
        <a
          href="https://firstock.in/termsandconditions"
          target="_blank"
          className={styles.bottomNavLink}
        >
          Terms & Conditions
        </a>
        <a
          href="https://firstock.in/policiesandprocedures"
          target="_blank"
          className={styles.bottomNavLink}
        >
          Policies & Procedures
        </a>
        <a
          href="https://docs.google.com/spreadsheets/d/1B5jrqYw1J4O7jbmmV5nBVEhxMDS6d4jTvnqecidM9ns/edit#gid=0"
          target="_blank"
          className={styles.bottomNavLink}
        >
          Investor Grievance
        </a>
        <a
          href="https://firstock.in/privacypolicy"
          target="_blank"
          className={styles.bottomNavLink}
        >
          Privacy Policy
        </a>
        <a
          href="https://firstock.in/disclosure"
          target="_blank"
          className={styles.bottomNavLink}
        >
          Disclosure
        </a>
        <a
          href="https://firstock.in/investorCharter"
          target="_blank"
          className={styles.bottomNavLink}
        >
          Investor Charter
        </a>
        <a
          href="https://firstock-common.s3.ap-south-1.amazonaws.com/new/FIRSTOCK+-+PMLA.pdf"
          target="_blank"
          className={styles.bottomNavLink}
        >
          PMLA Policy
        </a>
        <a
          href="https://firstock.in/investorAttention"
          target="_blank"
          className={styles.bottomNavLink}
        >
          Investor’s Attention
        </a>
        <a
          href="https://investor.sebi.gov.in/"
          target="_blank"
          className={styles.bottomNavLink}
        >
          SEBI - Investor website
        </a>
        <a
          href="https://www.bseipf.com/investors_education.html"
          target="_blank"
          className={styles.bottomNavLink}
        >
          Investor Education & Awareness
        </a>
        <a
          href="https://evoting.cdslindia.com/Evoting/EVotingLogin"
          target="_blank"
          className={styles.bottomNavLink}
        >
          E-Voting
        </a>
        <a
          href="https://www.nseindia.com/"
          target="_blank"
          className={styles.bottomNavLink}
        >
          NSE
        </a>
        <a
          href="https://www.bseindia.com/"
          target="_blank"
          className={styles.bottomNavLink}
        >
          BSE
        </a>
        <a
          href="https://www.cdslindia.com/"
          target="_blank"
          className={styles.bottomNavLink}
        >
          CDSL
        </a>
        <a
          href="https://www.cvlkra.com/"
          target="_blank"
          className={styles.bottomNavLink}
        >
          KYC Status
        </a>
        <a
          href="https://scores.sebi.gov.in/"
          target="_blank"
          className={styles.bottomNavLink}
        >
          SEBI SCORES
        </a>
        <a
          href="https://firstock-common.s3.ap-south-1.amazonaws.com/new/Policy-of-Handling-Good-Till-Trigger-Orders-of-Clients.pdf"
          target="_blank"
          className={styles.bottomNavLink}
        >
          Policy of Handling Good-Till-Trigger Orders
        </a>
        <a
          href="https://smartodr.in/login"
          target="_blank"
          className={styles.bottomNavLink}
        >
          Smart Online Dispute Resolution
        </a>
      </div>
    </div>
  );
}

export default FooterComp;
